import $ from "jquery";

const contentPopup = () => {
  const init = () => {
    handleScroll();
  };

  const el = {
    popup: ".js-section-content-popup",
    popupOverlay: ".js-bg-overlay-popup",
    closeIcon: ".js-icon-close",
  };

  const handleScroll = () => {
    if ($(el.popup).length === 0) return;

    $(el.popup).addClass("active");
    $(el.popupOverlay).addClass("active");

    // Close the popup when the close icon is clicked
    $(el.closeIcon).on("click", function () {
      $(el.popup).removeClass("active");
      $(el.popupOverlay).removeClass("active");
    });

    // Close the popup when clicking outside the popup
    $(document).on("click", function (event) {
      if (
        !$(event.target).closest(el.popup).length &&
        !$(event.target).is(el.popup)
      ) {
        // If the clicked element is not part of the popup or the popup itself
        $(el.popup).removeClass("active");
        $(el.popupOverlay).removeClass("active");
        $(".popup-overlay").removeClass("shows").addClass("hiddens");
      }
    });

    // Close the popup automatically after 40 seconds
    if ($("#popup-overl").length > 0) {
      const delay = $("#popup-overl").data("time_delay");
      setTimeout(() => {
        $(el.popup).removeClass("active");
        // $(el.popupOverlay).removeClass("active");

        //showPopup
        $("#popup-overl").removeClass("hiddens");
        $("#popup-overl").addClass("shows");
      }, delay * 1000);

      //bindCloseButton
      $("#pr-close-btn").on("click", function () {
        $("#popup-overl").removeClass("shows");
        $("#popup-overl").addClass("hiddens");
        $(el.popupOverlay).removeClass("active");
      });
    }
  };

  init();
};

try {
  contentPopup();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
